// extracted by mini-css-extract-plugin
export default {"container":"Events_container__WyAV2"};